<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-users-cog icon"></i>
        Tabla Respuestas
      </div>

      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{name:'administrativeHome'}">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'charts'}">
                <span>
                  <i class="fas fa-user-cog icon"></i>
                  Tabla Respuestas
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <ShowUserQuestionary
        v-if="isComponentModalActive"
        :questionary_id="questionary_id"
        :closeBasic="closeBasic"
        :isComponentModalActive="isComponentModalActive"
        >
        </ShowUserQuestionary>
        <ShowResultsQuestionary
        v-if="isComponentModalShowResultsActive"
        :questionary_id="questionary_id"
        :closeBasic="closeBasicShowResults"
        :isComponentModalActive="isComponentModalShowResultsActive"
        >
        </ShowResultsQuestionary>
        <div class="box">
          <b-table type="is-primary"
            :data.sync="listQuestionary"
            :loading="loading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="stablishment.name"
            aria-next-label="Next page"            
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="name" label="Nombre">{{ props.row.name }}</b-table-column>
              <b-table-column field="state" label="Estado">
                <span class="tag is-success" v-if="props.row.state=='Abierta'">
                    {{ props.row.state }}
                </span>
                <span class="tag is-danger"  v-if="props.row.state=='Cerrada'">
                    {{ props.row.state }}
                </span>
                <span class="tag is-info"  v-if="props.row.state=='Creada'">
                    {{ props.row.state }}
                </span>                
                </b-table-column>
              <b-table-column field="date_start" label="Fecha Inicio">{{ props.row.date_start }}</b-table-column>
              <b-table-column field="date_end" label="Fecha Termino">{{ props.row.date_end }}</b-table-column>
              <b-table-column field="action" label="Accion">
                <div class="buttons">
                  <b-button v-if='props.row.show_results=="1"' type="is-primary is-small" @click="openBasic(props.row.id)" >Ver Resultados</b-button>
                  <b-button type="is-info is-small" @click="openBasicShowResults(props.row.id)" >Ver Contador</b-button>
                </div>
              </b-table-column>

            </template>
          </b-table>
          
        </div>
      </div>

    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from "../../../template/PlantillaContenido";
import ShowUserQuestionary from "../../../components/administrative/chart/showUsersQuestionary"
import ShowResultsQuestionary from "../../../components/administrative/chart/showResultsQuestionary"

export default {
  components: {
    PlantillaContenido,
    ShowUserQuestionary,
    ShowResultsQuestionary,
  },
  data() {
    return {
      questionary_id: null,
      listQuestionary: [],
      isFullPage: true,
      isComponentModalActive: false,
      isComponentModalShowResultsActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5
    };
  },
  mounted: function() {
    this.chargeQuestionarieList();
  },
  methods: {
    openBasic(id) {
      this.questionary_id=id;
      this.isComponentModalActive = true;
    },
    closeBasic() {
      this.questionary_id = null;
      this.isComponentModalActive = false;
    },
    openBasicShowResults(id) {
      this.questionary_id=id;
      this.isComponentModalShowResultsActive = true;
    },
    closeBasicShowResults() {
      this.questionary_id = null;
      this.isComponentModalShowResultsActive = false;
    },
    chargeQuestionarieList() {
      this.loading = true;
      this.listQuestionary = [];
      this.$http.get(`api/${localStorage.getItem('perfil')}/questionary/find_by_state/Cerrada`).then(
        response => {
          this.listQuestionary = response.body.questionary;
          console.log('asasas',response.body.questionary)
          this.loading = false;
        },
        response => {
          console.log("error: ", response);
        }
      );
    }
  },
};
</script>


